import Api from './api.service';

// const ENDPOINT = 'banks';

export default {
  search: (term = '') => Api.get(`banks/list-banks?filter[name]=${term}`),
  getBank: (bank_number) =>
    Api.get(`banks/get-bank`, { params: { bank_number } }),
};
